import { Component } from '@angular/core';

@Component({
  selector: 'uxg-wizard-title',
  template: ` <ng-content></ng-content> `
})
export class UxgWizardTitleComponent {}
